import { rootApi } from "../../api/rootApi";

export const appUserDashboardApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllDashboardItems: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/admin/appDashboard",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),
    addDashboardItem: builder.mutation({
      query: (params) => {
        const formData = new FormData();
        formData.append("name", params.name);
        formData.append("action", params.action);
        formData.append("link", params.link);
        formData.append("order_at", params.order_at);
        formData.append("icon", params.icon);

        return {
          method: "POST",
          url: "/admin/appDashboard/add",
          headers: {
            Authorization: "Bearer " + params.token,
          },
          body: formData,
        };
      },
    }),
    deleteDashboardItem: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/admin/appDashboard/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),

    fetchAllAppUserDashboard: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/admin/appUserDashboard",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),
    addAppUserDashboard: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: "/admin/appUserDashboard/add",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + params.token,
          },
          body: params.data,
        };
      },
    }),
    updateAppUserDashboard: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/admin/appUserDashboard/update/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
          body: params.data,
        };
      },
    }),
    deleteAppUserDashboard: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/admin/appUserDashboard/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + params.token,
          },
        };
      },
    }),
  }),
});
export const {
  useAddAppUserDashboardMutation,
  useAddDashboardItemMutation,
  useDeleteDashboardItemMutation,
  useDeleteAppUserDashboardMutation,
  useFetchAllDashboardItemsMutation,
  useFetchAllAppUserDashboardMutation,
  useUpdateAppUserDashboardMutation,
} = appUserDashboardApi;
